import './App.css';
import Header from './component/Header';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './component/Home';
import About from './component/About';
import Footer from './component/Footer';
import Button from './component/Button';
function App() {
  return (
    <div className="App">
  <BrowserRouter>
<Header/>
<Routes>
<Route path='/' element={<Home/>}></Route>
<Route path='/about' element={<About/>}></Route>

</Routes>
<Button/>
<Footer/>

</BrowserRouter>
    </div>
  );
}

export default App;
